import { ReservationRolesEnum } from './ReservationRoles.enum';

export const ReservationRoles = [
  ReservationRolesEnum.Basic,
  ReservationRolesEnum.Advanced,
  ReservationRolesEnum.Approver,
  ReservationRolesEnum.Validator,
  ReservationRolesEnum.None,
];
